var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#DFDFDF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.31457 16.997C7.23062 16.9969 7.14761 16.9793 7.07083 16.9454C6.99405 16.9115 6.92517 16.8621 6.86859 16.8002C6.81098 16.7389 6.76702 16.6661 6.73959 16.5866C6.71216 16.5072 6.70189 16.4228 6.70944 16.3391L6.8577 14.713L13.7067 7.88398L15.847 10.0183L8.99989 16.8467L7.36964 16.9946C7.35134 16.9963 7.33296 16.9971 7.31457 16.997V16.997ZM16.2743 9.59154L14.1345 7.45724L15.418 6.17703C15.4742 6.12091 15.5409 6.07639 15.6144 6.04601C15.6879 6.01563 15.7666 6 15.8461 6C15.9256 6 16.0044 6.01563 16.0779 6.04601C16.1513 6.07639 16.2181 6.12091 16.2743 6.17703L17.5578 7.45724C17.614 7.5133 17.6587 7.57987 17.6891 7.65314C17.7196 7.72642 17.7352 7.80496 17.7352 7.88428C17.7352 7.9636 17.7196 8.04215 17.6891 8.11542C17.6587 8.1887 17.614 8.25527 17.5578 8.31132L16.2749 9.59094L16.2743 9.59154V9.59154Z",
    fill: "#5D5D5D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/Icon-Edit.66ac0246d354f675c7e525fb42d41a4d.svg";
export { ForwardRef as ReactComponent };